import { render, staticRenderFns } from "./ManualRejectsEntry.vue?vue&type=template&id=2b2a7dc4&scoped=true"
import script from "./ManualRejectsEntry.vue?vue&type=script&lang=js"
export * from "./ManualRejectsEntry.vue?vue&type=script&lang=js"
import style0 from "./ManualRejectsEntry.vue?vue&type=style&index=0&id=2b2a7dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a7dc4",
  null
  
)

export default component.exports